import { useState } from 'react';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';

import {
  UK_PRIVATE_COMPANY_INSIGHTS_BREADCRUMBS,
} from '../../../../data/ukPrivateCompanyInsights';
import { setAuthModalOpened } from '../../../../actions/authentication.actions';
import { addTopicNotification } from '../../../../actions/preferencesActions';
import { getTrendingBarAssetQuery } from '../../../../helpers/watchlistHelperFunctions';
import { getFormattedQuery } from '../../../../helpers/helpers';
import TopicsSvc from '../../../../services/TopicsSvc';

import Breadcrumbs from '../../../Breadcrumbs';
import Tooltip from '../../../Tooltip';
import WatchlistModal from '../../../Modals/WatchlistModal';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const SingleCompanieHeader = (props) => {
  const { currentCompany } = props;
  const mainWidth = useSelector(({ common }) => (
    common.width
  ));
  const userToken = useSelector(({ watchlistReducer }) => (
    watchlistReducer.userToken
  ));
  const subscriptionTopics = useSelector(({ userPreferencesReducer }) => (
    userPreferencesReducer.subscriptionTopics
  ));
  const [watchlistOpened, setWatchlistOpened] = useState(false);

  const dispatch = useDispatch();
  const openAuthModal = () => {
    dispatch(setAuthModalOpened(true));
  };

  const addToWL = () => {
    if (userToken) {
      setWatchlistOpened(!watchlistOpened);
      return;
    }
    openAuthModal();
  };

  const addPreferences = async () => {
    if (userToken) {
      const newTopic = await TopicsSvc.saveCompaniesData({
        legal_id: currentCompany.data.companyNumber,
        source: currentCompany.data.source,
      });
      newTopic.groups = [{
        groupName: newTopic.id,
        groupType: 'Topic',
      }];
      const assetTopicQuery = getTrendingBarAssetQuery(newTopic, 'Topic');
      const formattedQuery = getFormattedQuery(assetTopicQuery);
      dispatch(addTopicNotification(null, formattedQuery, null, subscriptionTopics));
      window.location.href = '/preferences/notifications';
      return;
    }

    openAuthModal();
  };

  const handleCloseModal = () => {
    setWatchlistOpened(false);
  };

  const SINGLE_INVESTOR_BREADCRUMBS = [
    ...UK_PRIVATE_COMPANY_INSIGHTS_BREADCRUMBS,
    {
      name: currentCompany.data?.name || '',
    },
  ];

  return (
    <div className={cx('single-companie-header')}>
      <Breadcrumbs
        base=""
        items={SINGLE_INVESTOR_BREADCRUMBS}
      />
      <div className={cx('single-companie-header-row')}>
        <div className={cx('single-companie-name')}>
          {currentCompany.data?.name || ''}
        </div>
        <div className={Styles.title_web_tab_button}>
          <Tooltip
            hasBigScreenDesign
            className={Styles.tooltip_add_wl}
            icon={(
              <div
                className={cx('add-to-wl')}
                onClick={addToWL}
                onTouchStart={addToWL}
              >
                <FontAwesomeIcon icon={faPlus} />
              </div>
            )}
          >
            {mainWidth >= 1024 ? 'Add topic to your watchlist' : ''}
          </Tooltip>
          <Tooltip
            hasBigScreenDesign
            className={Styles.tooltip_add_notification}
            icon={(
              <div
                className={cx('add-notifications')}
                onClick={addPreferences}
              >
                <FontAwesomeIcon icon={faBell} />
              </div>
              )}
          >
            {mainWidth >= 1024 ? 'Add topic to your notifications' : ''}
          </Tooltip>
        </div>
      </div>
      {watchlistOpened && (
        <WatchlistModal
          openModal={watchlistOpened}
          handleCloseModal={handleCloseModal}
          topic={currentCompany.data}
          createCompany
          type="Topic"
        />
      )}
    </div>
  );
};

export default SingleCompanieHeader;
